module.exports = __webpack_public_path__ + "static/img/autumn_liPic.5aab4870.png";